// extracted by mini-css-extract-plugin
module.exports = {"parts-diagram-menu":"parts-menu_parts-diagram-menu__5vVTp","cat-side-menu__container":"parts-menu_cat-side-menu__container__098z8"};